module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.messageList_x), function(item) {
    return _c('div', {
      staticClass: "dialogue"
    }, [_c('mu-list-item', {
      attrs: {
        "disableRipple": true
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": item._id === 0 ? 'rightAvatar' : 'leftAvatar',
        "src": item._id === 0 ? _vm.userData.self.avatar : _vm.userData.friend.avatar
      },
      slot: item._id === 0 ? 'rightAvatar' : 'leftAvatar'
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": item._id === 0 ? 'after' : 'title'
      },
      slot: item._id === 0 ? 'after' : 'title'
    }, [_c('span', {
      staticClass: "content",
      staticStyle: {
        "color": "rgba(0, 0, 0, .9)"
      }
    }, [_vm._v(_vm._s(item.message))])])], 1)], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ccc5e1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/dialogue.vue
// module id = 521
// module chunks = 1